module.exports = __webpack_public_path__ + "img/2.da7ebe0a.png";